/** Image-relative geometry shared by the preview and non-destructive export. */
export function imagePoint(x, y, boxWidth, boxHeight, imageWidth, imageHeight) {
  if (!(boxWidth > 0 && boxHeight > 0 && imageWidth > 0 && imageHeight > 0)) return null;
  const scale = Math.min(boxWidth / imageWidth, boxHeight / imageHeight);
  const width = imageWidth * scale, height = imageHeight * scale;
  const nx = (x - (boxWidth - width) / 2) / width;
  const ny = (y - (boxHeight - height) / 2) / height;
  return nx < 0 || nx > 1 || ny < 0 || ny > 1 ? null : { x: nx, y: ny };
}

export function paintRegionMask(canvas, strokes) {
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  for (const stroke of strokes) {
    if (!stroke.points.length) continue;
    ctx.globalCompositeOperation = stroke.erase ? 'destination-out' : 'source-over';
    ctx.fillStyle = ctx.strokeStyle = '#e83e79';
    ctx.lineCap = ctx.lineJoin = 'round';
    ctx.lineWidth = stroke.width * Math.min(canvas.width, canvas.height);
    const segments = [];
    for (const point of stroke.points) {
      if (point == null) { if (segments.at(-1)?.length) segments.push([]); }
      else { if (!segments.length) segments.push([]); segments.at(-1).push(point); }
    }
    for (const segment of segments) {
    if (!segment.length) continue;
    const [first, ...rest] = segment;
    ctx.beginPath();
    if (!rest.length) {
      ctx.arc(first.x * canvas.width, first.y * canvas.height, ctx.lineWidth / 2, 0, Math.PI * 2);
      ctx.fill();
    } else {
      ctx.moveTo(first.x * canvas.width, first.y * canvas.height);
      rest.forEach((p) => ctx.lineTo(p.x * canvas.width, p.y * canvas.height));
      ctx.stroke();
    }
    }
  }
  ctx.globalCompositeOperation = 'source-over';
}

export function maskHasArea(canvas) {
  const pixels = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data;
  for (let i = 3; i < pixels.length; i += 4) if (pixels[i]) return true;
  return false;
}

export function paintRegionGuide(canvas, image, mask) {
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  ctx.globalAlpha = 0.42;
  ctx.drawImage(mask, 0, 0);
  ctx.globalAlpha = 1;
}
